module.exports = __webpack_public_path__ + "img/VORON.ec7f61e8.png";